import { Box, Paper, styled, Typography } from "@mui/material";
import { JoyrideActivator } from "components/joyride/JoyrideActivator";

interface Color {
  r: number;
  g: number;
  b: number;
}

interface Props {
  score: number;
}
export function CustomGraph(props: Props) {
  const { score } = props;
  const colorScale = {
    startColor: { r: 255, g: 0, b: 0 },
    middleColor: { r: 255, g: 255, b: 0 },
    endColor: { r: 0, g: 128, b: 0 },
  };
  const scaleNumbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  function returnColor(
    firstColor: Color,
    secondColor: Color,
    percentage: number
  ) {
    const red = firstColor.r + percentage * (secondColor.r - firstColor.r);
    const green = firstColor.g + percentage * (secondColor.g - firstColor.g);
    const blue = firstColor.b + percentage * (secondColor.b - firstColor.b);
    return `rgb(${red}, ${green}, ${blue})`;
  }

  function getColorForPercentage(percentage: number) {
    if (percentage < 0.5) {
      return returnColor(
        colorScale.startColor,
        colorScale.middleColor,
        percentage * 2
      );
    } else {
      return returnColor(
        colorScale.middleColor,
        colorScale.endColor,
        (percentage - 0.5) * 2
      );
    }
  }

  return (
    <StyledPaper>
      <JoyrideActivator />
      <Box
        className={`label`}
        sx={{
          color: getColorForPercentage(score / 10),
          left: `${score * 10}%`,
        }}
      >
        <Typography>{score.toFixed(2)}</Typography>
      </Box>
      {scaleNumbers.map((number) => (
        <Box
          className="scale-label"
          key={number}
          sx={{
            left: `${number * 10}%`,
            color: getColorForPercentage(number / 10),
          }}
        >
          {number}
        </Box>
      ))}
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  width: 100%;
  height: 20px;
  background: linear-gradient(to right, red, yellow, green);

  position: relative;
  .scale-label {
    position: absolute;
    bottom: -150%;
    transform: translate(-50%);
    font-weight: bolder;
    font-size: 16px;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.7);
  }
  .label {
    position: absolute;
    font-weight: 700;
    top: -230%;
    transform: translate(-50%);
    z-index: 2;

    .MuiTypography-root {
      font-weight: bolder;
      font-size: 28px;
      text-shadow: rgba(0, 0, 0, 0.7) 0px 1px 1px;
    }
    ::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-top: solid 25px ${({ theme }) => theme.palette.common.black};
      border-left: solid 15px transparent;
      border-right: solid 15px transparent;
    }
  }

  @media print {
    -webkit-print-color-adjust: exact;
  }
`;
